/* eslint-disable class-methods-use-this */
import EventEmitter from 'eventemitter3';
import Promise from 'bluebird';

class PlayerBase extends EventEmitter {
    create(options) {
        return Promise.resolve(options);
    }

    insert() {
        return Promise.resolve();
    }

    delete() {
        return Promise.resolve();
    }

    play() {
        return Promise.resolve();
    }

    pause() {
        return Promise.resolve();
    }

    mute() {
        return Promise.resolve();
    }

    unmute() {
        return Promise.resolve();
    }

    error() {
        return Promise.resolve();
    }

    getPlayerConfigs() {
        return Promise.resolve();
    }

    updatePlayerConfigs(newConfigs) {
        return Promise.resolve(newConfigs);
    }

    getGeoLocation() {
        return Promise.resolve();
    }
}

export default PlayerBase;



// WEBPACK FOOTER //
// ./app/webapp/common/video-player/player-tech/PlayerBase.js